import {FormStatus, PaginatedSearch, UserRowData, UserToAdd} from "./shared";
import {SubscriptionType} from "./subscription-model";
import {ContactError, Machine} from "./machine.models";

export interface MemberToAdd extends UserToAdd{
    subscriptionType: SubscriptionType
}

export interface MembershipUserRowData extends UserRowData {
    subscriptionType?: SubscriptionType,
    language: string
}

export interface SearchMembersRequest extends PaginatedSearch{
    organizationId: number | undefined;
}

export interface SearchedMember {
    readonly userId: string;
    readonly userFirstName: string;
    readonly userLastName: string;
    readonly email: string;
    readonly organizationId: number;
    readonly organizationName: string;
    readonly organizationUnitId: number
    readonly organizationUnitName: string;
}

export enum AddMachineFormType {
    FromSearch = 1,
    FromEmail = 2
}

export interface MachineToAddModel {
    id: number,
    email: string,
    status: FormStatus
}

export interface AddMachineForm {
    id: number | string,
    type: AddMachineFormType
    data: Machine | MachineToAddModel,
    errors: ContactError,
    errorMessage?: string,
    status: FormStatus,
}
